/** Role identifiers, matching the values the API returns. */
export const ROLES = {
    EMPLOYEE: 'employee',
    SUPERVISOR: 'supervisor',
    DEPARTMENT_HEAD: 'department_head',
    HR: 'hr',
    PRINCIPAL: 'manager',
    ADMIN: 'admin',
};

export const ROLE_LABELS = {
    [ROLES.EMPLOYEE]: 'Employee / Staff',
    [ROLES.SUPERVISOR]: 'Supervisor',
    [ROLES.DEPARTMENT_HEAD]: 'Department Head',
    [ROLES.HR]: 'HR',
    [ROLES.PRINCIPAL]: 'Principal / Manager',
    [ROLES.ADMIN]: 'System Administrator',
};

/** Roles that see institution-wide data. */
export const MANAGEMENT = [ROLES.HR, ROLES.PRINCIPAL, ROLES.ADMIN];
/** Roles that can approve leave. */
export const LEAVE_APPROVERS = [ROLES.DEPARTMENT_HEAD, ...MANAGEMENT];
/** Roles that can see more than their own record. */
export const OVERSIGHT = [ROLES.SUPERVISOR, ROLES.DEPARTMENT_HEAD, ...MANAGEMENT];

export const hasRole = (role, allowed) => Boolean(role) && allowed.includes(role);
